import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["persons"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      injuryList: build.query<InjuryListApiResponse, InjuryListApiArg>({
        query: (queryArg) => ({
          url: `/api/persons/${queryArg.personId}/injuries/`,
        }),
        providesTags: ["persons"],
      }),
      injuryCreate: build.mutation<InjuryCreateApiResponse, InjuryCreateApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/persons/${queryArg.personId}/injuries/`,
            method: "POST",
            body: queryArg.createInjury,
          }),
          invalidatesTags: ["persons"],
        },
      ),
      injuryRetrieve: build.query<
        InjuryRetrieveApiResponse,
        InjuryRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons/${queryArg.personId}/injuries/${queryArg.id}/`,
        }),
        providesTags: ["persons"],
      }),
      injuryUpdate: build.mutation<InjuryUpdateApiResponse, InjuryUpdateApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/persons/${queryArg.personId}/injuries/${queryArg.id}/`,
            method: "PUT",
            body: queryArg.updateInjury,
          }),
          invalidatesTags: ["persons"],
        },
      ),
      injuryDestroy: build.mutation<
        InjuryDestroyApiResponse,
        InjuryDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons/${queryArg.personId}/injuries/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["persons"],
      }),
      injuryAccept: build.mutation<InjuryAcceptApiResponse, InjuryAcceptApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/persons/${queryArg.personId}/injuries/${queryArg.id}/accept/`,
            method: "POST",
          }),
          invalidatesTags: ["persons"],
        },
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type InjuryListApiResponse = /** status 200  */ ReadInjury[];
export type InjuryListApiArg = {
  personId: string;
};
export type InjuryCreateApiResponse = /** status 201  */ ReadInjury;
export type InjuryCreateApiArg = {
  personId: string;
  createInjury: CreateInjury;
};
export type InjuryRetrieveApiResponse = /** status 200  */ ReadInjury;
export type InjuryRetrieveApiArg = {
  id: string;
  personId: string;
  pk: string;
};
export type InjuryUpdateApiResponse = /** status 200  */ ReadInjury;
export type InjuryUpdateApiArg = {
  id: string;
  personId: string;
  pk: string;
  updateInjury: UpdateInjury;
};
export type InjuryDestroyApiResponse = unknown;
export type InjuryDestroyApiArg = {
  id: string;
  personId: string;
  pk: string;
};
export type InjuryAcceptApiResponse = /** status 200  */ ReadInjury;
export type InjuryAcceptApiArg = {
  id: string;
  personId: string;
  pk: string;
};
export type BodyPart =
  | "head"
  | "face"
  | "cervical_spine"
  | "shoulder_left"
  | "shoulder_right"
  | "arm_left"
  | "arm_right"
  | "elbow_left"
  | "elbow_right"
  | "wrist_left"
  | "wrist_right"
  | "hand_left"
  | "hand_right"
  | "chest"
  | "thoracic_spine"
  | "lumbar_spine"
  | "abdomen"
  | "hip_left"
  | "hip_right"
  | "leg_left"
  | "leg_right"
  | "knee_left"
  | "knee_right"
  | "ankle_left"
  | "ankle_right"
  | "foot_left"
  | "foot_right"
  | "other";
export type EntitySuggestionStatus = "suggested" | "accepted" | "rejected";
export type ReadInjury = {
  body_part: BodyPart;
  description?: string | null;
  id: string | string;
  person_id: string | string;
  approval_status?: EntitySuggestionStatus;
  created_at: string;
  modified_at: string;
};
export type CreateInjury = {
  body_part: BodyPart;
  description?: string | null;
  person_id: string | string;
};
export type UpdateInjury = {
  body_part?: BodyPart;
  description?: string | null;
  id: string | string;
};
export const {
  useInjuryListQuery,
  useInjuryCreateMutation,
  useInjuryRetrieveQuery,
  useInjuryUpdateMutation,
  useInjuryDestroyMutation,
  useInjuryAcceptMutation,
} = injectedRtkApi;
